<template>
	<div class="main">
		<header class="page-title">
			<h2>{{ data.name }} Review</h2>
		</header>
		<div class="flex box article-content">
			<div class="eight">
				<provider-review-editor-content :editor-content="data.providerReviewEditorContent" :errors="errors"></provider-review-editor-content>
			</div>
			<aside class="four">
				<provider-review-editor-general :editor-general="data.providerReviewEditorGeneral" :generated-url="generatedUrl" :auth-pixel-hash="authPixelHash" :errors="errors"></provider-review-editor-general>
				<provider-review-editor-toc-helper :table-of-contents="data.tableOfContents" :editor-content="data.providerReviewEditorContent"></provider-review-editor-toc-helper>
				<provider-review-editor-video-helper :editor-content="data.providerReviewEditorContent" :provider-id="data.id"></provider-review-editor-video-helper>
				<provider-review-editor-health-checker :editor-health-checker="data.providerReviewEditorHealthChecker"></provider-review-editor-health-checker>
			</aside>
		</div>
		<modal @close="closeModal" v-show="isModalVisible">
			<template slot="header">
				<h4 class="modal-title" v-if="healthCheckerErrors.length === 0">Confirm Review Publication</h4>
				<h4 class="modal-title" v-if="healthCheckerErrors.length > 0">Please fix these issues before publishing</h4>
			</template>
			<template slot="body">
				<div class="flex box">
					<div class="seven">
						<div class="flex box">
							<div class="form-group twelve-lg" v-if="healthCheckerErrors.length > 0">
								<table>
									<thead>
										<tr>
											<th>Rule</th>
											<th>Error</th>
										</tr>
									</thead>
									<tbody>
										<tr v-bind:class="{ 'text-danger': result.result === 300 }" v-for="result in healthCheckerErrors">
											<td>{{ result.rule }}</td>
											<td class="text-center"
												v-bind:class="{
													'text-success': result.result === 0,
													'text-warning': result.result === 100,
													'text-danger': result.result === 200 || result.result === 300,
												}">
												{{ result.message }}
												<ul v-if="result.items.length > 0">
													<li v-for="item in result.items" v-if="item.code === 200">{{ item.text }}</li>
												</ul>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template slot="footer" v-if="healthCheckerErrors.length === 0">
				<a class="btn btn-md btn-success" @click="publish" :disabled="!canWePublish"><i class="fas fa-check"></i> Publish</a>
				<a class="btn btn-md btn-danger" @click="closeModal"><i class="fas fa-trash"></i> Cancel</a>
			</template>
			<template slot="footer" v-if="healthCheckerErrors.length > 0">
				<a class="btn btn-md btn-success" @click="closeModal"><i class="fas fa-check"></i> Go Fixing</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import {eventBus} from "../../../app";
	import Errors from "../../../Utils/Errors";
	import modal from "../../Modal/DefaultModal.vue";

	export default {
		components: {
			modal
		},
		props: {
			data: {
				required: true
			},
			dataAuthPixelHash: {
				type: String
			},
		},
		data() {
			return {
				isModalVisible: false,
				healthCheckerErrors: [],
				canWePublish: false,
				clickedLang: this.$defaultLanguage.locale,
				authPixelHash: this.dataAuthPixelHash,

				errors: new Errors()
			}
		},
		created() {
			let vm = this;
			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});

			eventBus.$on('onProviderReviewSaveDraft', function () {
				vm.saveDraft();
			});

			eventBus.$on('onProviderReviewSaveDraftAndPublish', function () {
				vm.prePublishModal();
			});

			eventBus.$on('onProviderReviewDeleteDraft', function () {
				axios.delete('/api/' + vm.$selectedSite.slug + '/providers/' + vm.data.id + '/review')
						.then(function (response) {
							if (response.data) {
								vm.data = response.data;
								eventBus.$emit('onLoaderFinish');
								vm.$toastr.success('Provider review draft deleted.', 'Success');
							}
						})
						.catch(function (e) {
							eventBus.$emit('onLoaderFinish');
							vm.$toastr.error('Provider review draft delete failed.', 'Error');
							vm.errors.record(e.response.data);
						});
			});
		},
		beforeDestroy() {
			eventBus.$off('onProviderReviewSaveDraft');
			eventBus.$off('onProviderReviewSaveDraftAndPublish');
			eventBus.$off('onProviderReviewDeleteDraft');
		},
		computed: {
			generatedUrl: function () {
				const baseUrl = import.meta.env.MIX_BASE_PP_URL || '';
				return baseUrl.replace(/\/$/g, '') + (this.clickedLang === 'en' ? '' : '/' + this.clickedLang);
			},
		},
		methods: {
			saveDraft: function (callback) {
				let vm = this;
				let originData = _.cloneDeep(vm.data);
				for (let i = 0; i < this.$availableLanguages.length; i++) {
					if (originData.providerReviewEditorContent['translations'][this.$availableLanguages[i].locale] &&
							(originData.providerReviewEditorContent['translations'][this.$availableLanguages[i].locale].tagline === '' || originData.providerReviewEditorContent['translations'][this.$availableLanguages[i].locale].tagline === null) &&
							(originData.providerReviewEditorContent['translations'][this.$availableLanguages[i].locale].above_the_fold === '' || originData.providerReviewEditorContent['translations'][this.$availableLanguages[i].locale].above_the_fold === null) &&
							(originData.providerReviewEditorContent['translations'][this.$availableLanguages[i].locale].content === '' || originData.providerReviewEditorContent['translations'][this.$availableLanguages[i].locale].content === null)) {
						delete (originData.providerReviewEditorContent['translations'][this.$availableLanguages[i].locale]);
					}
				}
				axios.post('/api/' + vm.$selectedSite.slug + '/providers/' + vm.data.id + '/review/save-draft', originData)
						.then(function (response) {
							if (response.data) {
								if (response.data.hasOwnProperty('success') && !response.data.success) {
									eventBus.$emit('onLoaderFinish');
									vm.$toastr.error('Provider review draft save failed.', 'Error');
								}

								vm.data.providerReviewEditorHealthChecker.result = response.data.reviewHealth;
								eventBus.$emit('onLoaderFinish');
								if (callback) {
									callback();
								}
								vm.$toastr.success('Provider review draft saved.', 'Success');
							}
						})
						.catch(function (e) {
							eventBus.$emit('onLoaderFinish');
							vm.$toastr.error('Provider review draft save failed.', 'Error');
							vm.errors.record(e.response.data);
						});
			},
			publish: function () {
				let vm = this;
				vm.saveDraft(function () {
					axios.post('/api/' + vm.$selectedSite.slug + '/providers/' + vm.data.id + '/review/publish')
							.then(function (response) {
								if (response.data) {
									eventBus.$emit('onLoaderFinish');
									vm.$toastr.success('Provider review published.', 'Success');
								}
							})
							.catch(function (e) {
								eventBus.$emit('onLoaderFinish');
								vm.$toastr.error('Provider review publish failed.', 'Error');
								vm.errors.record(e.response.data);
							});
				});
			},
			prePublishModal: function () {
				this.getHealthCheckerErrors();
				if (this.healthCheckerErrors.length === 0) {
					return this.publish();
				} // if
				this.canWePublish = false;
				this.isModalVisible = true;
			},
			getHealthCheckerErrors: function () {
				let vm = this;
				this.healthCheckerErrors = [];

				if (this.data.id && this.data.hasOwnProperty('providerReviewEditorHealthChecker') && this.data.providerReviewEditorHealthChecker.hasOwnProperty('result') && typeof this.data.providerReviewEditorHealthChecker.result !== 'undefined' && this.data.providerReviewEditorHealthChecker.result.length > 0) {
					this.data.providerReviewEditorHealthChecker.result.forEach(function (entry) {
						if (entry.result > 100) {
							vm.healthCheckerErrors.push(entry);
						}
					});
				}
			},
			closeModal: function () {
				this.isModalVisible = false;
				eventBus.$emit('onLoaderFinish');
			},
		}
	}
</script>

<style scoped>

</style>
